module.exports = __webpack_public_path__ + "static/media/hobbies.4c945292.png";